export function getUniqueAliasEntries(aliases: string[]): Array<{ alias: string; index: number }> {
  const seen = new Set<string>()
  const out: Array<{ alias: string; index: number }> = []

  aliases.forEach((alias, index) => {
    if (seen.has(alias)) return
    seen.add(alias)
    out.push({ alias, index })
  })

  return out
}

export function formatUrl(url?: string): string | null {
  if (!url) return null
  return url.startsWith('http') ? url : `https://${url}`
}
